import { render, staticRenderFns } from "./HutangBalance.vue?vue&type=template&id=049df2e4&scoped=true&"
import script from "./HutangBalance.vue?vue&type=script&lang=js&"
export * from "./HutangBalance.vue?vue&type=script&lang=js&"
import style0 from "./HutangBalance.vue?vue&type=style&index=0&id=049df2e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049df2e4",
  null
  
)

export default component.exports